import { h } from './pragma.mjs';
export default function (isPublic) {

    if (isPublic) {
        return (<div class="vdp-col-6" id="main"></div>)
    } else {

        return (

            <div class="vdp-col-6" id="main">


                <h2>Moje návrhy</h2>

                <div class="table-frame">
                    <table class="vdp-tabulka">
                        <tbody id="rozpracovaneTable">
                            <tr>
                                <th>Služba</th>
                                <th>Vytvořeno</th>
                                <th>Naposledy editováno</th>
                                <th>Stav</th>
                                <th style="width: 40px;">&nbsp;</th>
                            </tr>

                        </tbody>
                    </table>
                </div>

            </div>
        )

    }


}